import { render, staticRenderFns } from "./CardNoDataText.vue?vue&type=template&id=1c5fd3f6"
import script from "./CardNoDataText.vue?vue&type=script&lang=js"
export * from "./CardNoDataText.vue?vue&type=script&lang=js"
import style0 from "./CardNoDataText.vue?vue&type=style&index=0&id=1c5fd3f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports